var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.opened)?_c('div',{staticClass:"dropdown-shifter",style:(_vm.styles)},[_vm._t("default",null,{"top":_vm.top,"left":_vm.left})],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }